export default __webpack_public_path__ + "static/media/2401.bcc3bb51.png";